import { DownloadIcon, Loader2Icon } from 'lucide-react'
import React, { ReactNode } from 'react'

import { useExport } from '@/lib/ui/export.hook'
import { cn } from '@/lib/ui/style-helpers'

import { Button, ButtonProps } from '@/components/lemmala-design-system/button/button'
import '@/components/shared/export-button/print.less'

import './print.less'

type ExportButtonProps = {
  getExportContent: () => { exportContent: ReactNode; renderContent: () => void; isLoaded: boolean }
  documentTitle?: string
} & ButtonProps

export const ExportButton = ({
  getExportContent,
  documentTitle,
  onClick,
  className,
  variant = 'outline',
  ...props
}: ExportButtonProps) => {
  const { isExporting, handleExport, ExportContent } = useExport(getExportContent, {
    documentTitle,
  })

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    handleExport()
    onClick?.(e)
  }

  return (
    <>
      <Button
        onClick={handleClick}
        disabled={isExporting}
        variant={variant}
        className={cn('gap-2', className)}
        {...props}
      >
        {isExporting ? (
          <Loader2Icon className='size-4 animate-spin' />
        ) : (
          <DownloadIcon strokeWidth={2} className='size-4' />
        )}
        Export
      </Button>

      <ExportContent />
    </>
  )
}
